// src/context.js
import React, { createContext, useState, useContext } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Existing filters
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({
    mainCategory: "",
    subCategory: "",
    subSubCategory: "",
  });

  // New: Plot Area and FSI data
  const [plotData, setPlotData] = useState({
    district: "",
    taluka: "",
    village: "",
    surveyNumber: "",
    grossPlotArea: 0,
    dpRoadArea: 0,
    otherReserveArea: 0,
    totalReservation: 0,
    netPlotArea: 0,
    areaType: "",
    authorityType: "",
    roadWidth: "",
    basicFSIFactor: 0,
    premiumFSIFactor: 0,
    maxTDRFactor: 0,
    tdrFactor: 0,
  });

  return (
    <AppContext.Provider
      value={{
        selectedCategory,
        setSelectedCategory,
        searchText,
        setSearchText,
        filter,
        setFilter,
        plotData,
        setPlotData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
